var render, staticRenderFns
import script from "./ContentFeedReviews.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedReviews.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedReviews.vue?vue&type=style&index=0&id=fb697648&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb697648",
  null
  
)

export default component.exports